<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="用戶評分管理"
      fkey="us01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="formDataObj"
      @customValueChanged="optionValueChanged"
    ></populate-form>
    <b-table striped stacked="sm" hover :items="ScoreResults" :fields="fields">
      <template v-slot:cell(lv1_score)="row">
        <star-rating
          v-model="row.item.lv1_score"
          :starSize=20
          :read-only="true"
          :show-rating="false"
        ></star-rating>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button size="sm" @click.stop="showDetailPopup(row, row.index, $event.target)" class="mr-1">
          看詳細
        </b-button>
      </template>
    </b-table>
    <b-modal 
      id="detailModal"
      ref="detailModal"
      v-model="modalShow"
      :static="true"
      size="lg"
      centered
      hide-header
      hide-footer
      @shown="setFocus"
    >
      <populate-form
        formTitle="查看評分詳細"
        fkey="vw01"
        ref="popupForm"
        populateOptionVar="popupOptions"
        formDataObjVar="PopupRow"
        :parentVue="this"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  apiGetMerchantAutoComplete,
  apiGetMerchantList,
  apiGetMerchantById
} from '@/api/AdminManage.js'

import {
  apiGetUserFeedbackList
} from '@/api/CustomerServices.js'

export default {
  name: 'UserScoreManage',
  components: {

  },
  data: function () {
    return {
      isLoading:false,
      formDataObj: {},
      filterOptions:[
        {
          'componentType':'vue-single-select',
          'optionVar':'Merchants',
          'defaultValue':null,
          'akey':'SelectedMerchantItem',
          'asyncFetchCB': this.loadMerchantByKeyword,
          'optionLabel':'merchant_full_name',
          'col':12,
          'placeholder':'篩選供應商',
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Stores',
          'defaultValue':null,
          'akey':'selectedStore',
          'optionLabel':'store_name',
          'col':4,
          'placeholder':"請選擇分店"
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Services',
          'defaultValue':null,
          'akey':'selectedServiceItem',
          'optionLabel':'service_name',
          'col':8,
          'placeholder':"請選擇課程"
        },
        {
          'componentType':'b-form-select',
          'akey':'lv1_score',
          'defaultValue':'0',
          'col':3,
          'dataOptions':[{text:'任何評價',value:'0'},{text:'1星',value:'1'},{text:'2星',value:'2'},{text:'3星',value:'3'},{text:'4星',value:'4'},{text:'5星',value:'5'},{text:'1~2星',value:'12'}]
        },
        {
          'componentType':'date-picker',
          'akey':'filter_start_date',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選時段日期起",
          'title':"篩選時段日期起：若指定將只回傳評分時間在此日期以後者",
        },
        {
          'componentType':'date-picker',
          'akey':'filter_end_date',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選時段日期迄",
          'title':"篩選時段日期迄：若指定將只回傳評分時間在此日期以前者",
        },
        {
          'componentType':'b-button',
          'akey':'button1',
          'col':3,
          'placeholder':"查詢",
          'execCallback':this.GoSearch
        },
      ],
      showFilter: true,
      datePicketOptions: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
      },
      fields: [
        {
          key: 'lv1_score',
          label: '評分',
          sortable: false
        },
        {
          key: 'scorer_name',
          label: '評分者'
        },
        {
          key: 'store_name',
          label: '店家',
          sortable: false
        },
        {
          key: 'created_at',
          label: '評分時間',
          sortable: false
        },
        {
          key: 'ticket_scan_time',
          label: '服務時間',
          sortable: false
        },
        {
          key: 'service_name',
          label: '服務課程',
          sortable: false
        },        
        {
          key: 'actions',
          label: '功能'
        }
      ],
      dismissSecs: 1,
      dismissCountDown: 0,
      modalShow: false,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      CachedMerchant: Object, //用merchant_id當key的merchant_info cache
      CachedLoginStores: Object, //用merchant_store_id當key的merchant_store login cache
      Stores: [],
      SelectedStoreId: null,
      SelectedStoreAccount: '',
      Services: [],
      SelectedServiceId: null,
      //SelectedServiceItemId: null,
      PageNumber: 1,
      ItemsPerPage: 500,
      ScoreResults: [],
      popupOptions:[
        {
          componentType:'span',
          akey:'service_name',
          col:12,
          placeholder:"",
        },
        {
          componentType:'span',
          col:12,
          placeholder:"　", // 換行擠一個空白行需要用全形空白否則會沒高度
        },
        {
          componentType:'span',
          col:3,
          placeholder:"評分者:",
        },
        {
          componentType:'span',
          akey:'scorer_name',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          col:3,
          placeholder:"服務店家:",
        },
        {
          componentType:'span',
          akey:'store_name',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          col:3,
          placeholder:"服務於:",
        },
        {
          componentType:'span',
          akey:'ticket_scan_time',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          col:3,
          placeholder:"評分於",
        },
        {
          componentType:'span',
          akey:'created_at',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          col:3,
          placeholder:"整體評分:",
        },
        {
          componentType:'star-rating',
          akey:'lv1_score',
          col:3,
          disabled:true,
          showRating:true,
          placeholder:"",
        },
        {
          componentType:'span',
          col:3,
          placeholder:"會員編號:",
        },
        {
          componentType:'span',
          akey:'member_id',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          col:3,
          placeholder:"訂單編號:",
        },
        {
          componentType:'span',
          akey:'bill_id',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          col:12,
          placeholder:"低分明細",
        },
        {
          componentType:'span',
          col:2,
          placeholder:"店家評價:"
        },
        {
          componentType:'star-rating',
          akey:"score_12_store_score",
          disabled:true,
          col:2,
          placeholder:""
        },
        {
          componentType:'span',
          col:2,
          placeholder:"美容師:"
        },
        {
          componentType:'star-rating',
          akey:"score_12_servant_score",
          disabled:true,
          col:2,
          placeholder:""
        },
        {
          componentType:'span',
          col:2,
          placeholder:"課程:"
        },
        {
          componentType:'star-rating',
          akey:"score_12_class_score",
          disabled:true,
          col:2,
          placeholder:""
        },
        {
          componentType:'span',
          col:2,
          placeholder:"低分留言"
        },
        {
          componentType:'span',
          akey:"score_12_other",
          col:10,
          placeholder:""
        },
        {
          componentType:'btn-group',
          akey:'btn-group',
          col:12,
          buttons:[
            {
              akey:"btnclose",
              col:4,
              placeholder: "關閉",
              execCallback: this.closePopup
            }
          ]
        },
      ],
      PopupIndex: 0,
      PopupRow: {},
    }
  },
  props: [

  ],
  methods: {
    optionValueChanged(upd) {
      if (upd.key === 'SelectedMerchantItem') {
        this.SelectedMerchant = upd.val
        this.changeMerchant(upd.val)
      }
      else if (upd.key === 'selectedStore') {
        this.SelectedStoreId = upd.val?upd.val.id:null
        this.changeStore()
      }
      else if (upd.key === 'selectedServiceItem') {
        this.SelectedServiceId = upd.val?upd.val.merchant_service_id:null
      }
      else if (upd.key === 'lv1_score') {
        this.GoSearch()
      }
    },
    GoSearch () {
      setTimeout(() => {
        this.loadScoreResults()
      }, 200);
    },
    FocusQuery () {
      this.$refs.BtnQuery.focus()
    },
    loadScoreResults () {
      if (this.isLoading) {
        return
      }
      // 效能考量不給全抓
      // SelectedMerchantId為空時,自動把日期指定為當天
      let Param = {
        'module':'customer_service',
        'method':'getUserFeedbackList',
        'merchant_id':this.SelectedMerchantId?this.SelectedMerchantId:0,
        'merchant_store_id':this.SelectedStoreId?this.SelectedStoreId:0,
        'merchant_service_id':this.SelectedServiceId?this.SelectedServiceId:0,
        'filter_start_date':this.formDataObj.filter_start_date?this.formDataObj.filter_start_date:'',
        'filter_end_date':this.formDataObj.filter_end_date?this.formDataObj.filter_end_date:'',
        //'user_name':this.formDataObj.user_name,
        'lv1_score':this.formDataObj.lv1_score,
        'page_number':this.PageNumber,
        'items_per_page':this.ItemsPerPage,
      }
      if (Param.filter_start_date) {
        Param.filter_start_date = Param.filter_start_date.replaceAll('/', '-') 
      }
      if (Param.filter_end_date) {
        Param.filter_end_date = Param.filter_end_date.replaceAll('/', '-') 
      }

      this.isLoading = true
      let vm = this
      apiGetUserFeedbackList(Param).then(function(resp){
        let data = resp.data
        vm.ScoreResults = data.data.rawFeedbackList
      }).then(function(error){
        console.log(error)
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })
      vm.isLoading = false
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       vm.isLoading = false
      //       return
      //     }
      //     vm.ScoreResults = data.data.rawFeedbackList
      //     vm.isLoading = false
      // },this)
    },
    showDetailPopup: function (row, index) {
      this.PopupRow = this.CpObj(row.item)
      // 要呼叫這個才能讓form的顯示與model數據保持一致
      this.$refs.popupForm.refreshModelVar()
      this.PopupIndex = index
      this.modalShow = true
    },
    loadMerchantByKeyword (keyword) {
      console.log('K>')
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Merchants = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getMerchantAutoComplete',
        'keyword':keyword,
      }
      console.log(Param)
      let vm = this
      apiGetMerchantAutoComplete(Param).then(function(resp){
        let data = resp.data
        vm.Merchants = data.data.matched_merchant_list
      }).catch(function(error){
        let data = error.response.data
        console.log(error)
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     vm.Merchants = data.data.matched_merchant_list
      // },this)
    },
    loadMerchants () {
      let Param = {
        'module':'admin_manage',
        'method':'get_merchant_list',
        'merchant_name':'',
      }
      let vm = this
      apiGetMerchantList(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        vm.Merchants = data.data
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.Merchants = data.data
      // },this)
    },
    changeMerchant(merchant) {
      // eslint-disable-next-line
      if (merchant) {
        this.SelectedMerchantId = merchant.merchant_id
      }
      else {
        this.SelectedMerchantId = null
      }
      setTimeout(() => {
        this.loadMerchantById()
        this.loadScoreResults()
      }, 100);
    },
    changeStore() {
      // 直接呼叫載入選定的商家會失敗...囧
      // 雖然看預約本身不需要登入,但要便利的查預約者手機就需要模擬登入了
      setTimeout(() => {
        this.loadScoreResults()
      }, 100);
    },
    loadMerchantById() {
      if (this.SelectedMerchantId === null ) {
        this.Stores = []
        this.SelectedStoreId = null
        this.SelectedStoreAccount = ''
        this.Services = []
        this.SelectedServiceId = null
        this.formDataObj.selectedStore = null
        this.formDataObj.selectedServiceItem = null
        this.$refs.filterForm.refreshModelVar('selectedStore,selectedServiceItem')
        return false
      }
      // 回到預設
      this.Stores = []
      this.SelectedStoreId = null
      this.SelectedStoreAccount = ''
      this.Services = []
      this.SelectedServiceId = null
      this.formDataObj.selectedStore = null
      this.formDataObj.selectedServiceItem = null
      // 先判斷cache
      if (this.CachedMerchant.hasOwnProperty('m_'+this.SelectedMerchantId)) {
        // this.formDataObj.SelectedMerchantItem = this.CachedMerchant['m_'+this.SelectedMerchantId]
        this.Stores = this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_stores
        // 課程目前階段有兩層,需要先處理再產生下拉選單數據
        let services = []
        for (let i=0;i<this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects.length;i++) {
          let item = {
              ticket_project_id:this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects[i].id,
              merchant_service_id:this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
              service_name:this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects[i].ticket_services[0].service_name,
              product_id:this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects[i].product_id
          }
          services.push(item)
        }
        this.Services = this.CpObj(services)
        this.$refs.filterForm.refreshModelVar('selectedStore,selectedServiceItem')
      }
      else {
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':this.SelectedMerchantId,
        }
        let vm = this
        apiGetMerchantById(Param).then(function(resp){
          let data = resp.data
          vm.Stores = data.data.merchant_stores
          let services = []
          for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
            let item = {
                ticket_project_id:data.data.merchant_ticket_projects[i].id,
                merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
                service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
                product_id:data.data.merchant_ticket_projects[i].product_id
            }
            services.push(item)
          }
          vm.Services = vm.CpObj(services)
          vm.$refs.filterForm.refreshModelVar('selectedStore,selectedServiceItem')
          vm.CachedMerchant['m_'+vm.SelectedMerchantId] = data.data
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //       return
        //     }
        //     vm.Stores = data.data.merchant_stores
        //     let services = []
        //     for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
        //       let item = {
        //           ticket_project_id:data.data.merchant_ticket_projects[i].id,
        //           merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
        //           service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
        //           product_id:data.data.merchant_ticket_projects[i].product_id
        //       }
        //       services.push(item)
        //     }
        //     vm.Services = vm.CpObj(services)
        //     vm.$refs.filterForm.refreshModelVar('selectedStore,selectedServiceItem')
        //     vm.CachedMerchant['m_'+vm.SelectedMerchantId] = data.data
        // },this)
      }
    },
    showCreate () {
      this.modalShow = true
    },
    closePopup () {
      this.modalShow = false
    },
    setFocus () {

    },
    getScoresEnterPageUrl: function(){
      const queryString = window.location.search;
      console.log(queryString);
      const urlParams = new URLSearchParams(queryString);

      let param = {
        filter_start_date: urlParams.get('start_at'),
        filter_end_date: urlParams.get('end_at'),
        'lv1_score': 0,
        'page_number': 1,
        'items_per_page': 500,
      }

      if (urlParams.get('supplier_id')) {
        param['supplier_id'] = urlParams.get('supplier_id')
      }

      if (urlParams.get('store_id')) {
        param['store_id'] = urlParams.get('store_id')
      }

      if (urlParams.get('product_id')) {
        param['product_id'] = urlParams.get('product_id')
      }

      this.isLoading = true
      let vm = this
      apiGetUserFeedbackList(param).then(function(resp){
        let data = resp.data
        vm.ScoreResults = data.data.rawFeedbackList
      }).then(function(error){
        console.log(error)
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })
      vm.isLoading = false

    }
  },
  computed: {
    
  },
  created: function () {
    // 抓api拿merchant
    // this.loadMerchants()
  },
  mounted () {
    this.isLoading = true
    this.$off('modal-template-create-close')
    this.$on('modal-template-create-close', function () {
      this.modalShow = false
    }.bind(this))
    this.$refs.filterForm.initDefault()
    this.formDataObj.filter_start_date = this.getDateByStr('',-6)
    this.formDataObj.filter_end_date = this.getDateByStr('',0)
    this.$refs.filterForm.refreshModelVar()
    //一進來就查詢碰到有execCallback組件變更查詢時,要先關閉等久一點再撈,不然isLoading抗不住瞬間重複呼叫仍會因瞬間變更多次而瞬間呼叫
    setTimeout(() => {
      this.isLoading = false
      if (window.location.search) {
        this.getScoresEnterPageUrl()
      }
      else {
        this.loadScoreResults()
      }
    }, 1000);


  },
  watch:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.tooltip-wrapper {
  display: inline-block;
}
.tooltip-wrapper >>> b-button {
  pointer-events: none;
}
</style>
